{
  "ddd, MMM D, YYYY": "ddd, D MMM YYYY",
  "h:mm A z": "HH:mm z",
  "Video fragment {number}": "Fragment wideo {number}",
  "Upload to Beginning": "Prześlij na początek",
  "Upload to End": "Prześlij na koniec",
  "Replace All Video": "Zastąp całe wideo",
  "Total length: {duration}": "Łączna długość: {duration}",
  "Upload After": "Prześlij po tym fragmencie",
  "Delete this uploaded video?": "Usunąć to przesłane wideo?",
  "Delete this video fragment?": "Usunąć ten fragment wideo?",
  "Video fragment deleted": "Usunięto fragment wideo",
  "Could not delete video fragment": "Nie udało się usunąć fragmentu wideo",
  "Loading event video...": "Wczytywanie wideo wydarzenia...",
  "Deleting video fragment...": "Usuwanie fragmentu wideo...",
  "Loading uploaded video fragments...": "Wczytywanie przesłanych fragmentów wideo...",
  "Could not finish upload": "Nie udało się zakończyć przesyłania",
  "Could not queue video conversion": "Nie udało się dodać wideo do kolejki konwersji",
  "Event video is uploaded and will be processed now": "Wideo wydarzenia zostało przesłane i będzie teraz przetwarzane",
  "Upload an edited or backup recording of the live stream. This will replace the current video on event page.": "Prześlij zmontowane lub zapasowe nagranie transmisji na żywo. Zastąpi ono obecne wideo na stronie wydarzenia.",
  "Upload video to event page. Video will show on event page before Live Stream starts. Once you go Live, the live stream will replace the uploaded video automatically": "Prześlij wideo na stronę wydarzenia. Będzie widoczne na stronie wydarzenia przed rozpoczęciem transmisji na żywo. Gdy rozpoczniesz transmisję, automatycznie zastąpi ona przesłane wideo",
  "Delete Uploaded Video?": "Usunąć przesłane wideo?",
  "Notify all guests when it's uploaded": "Powiadom wszystkich gości po przesłaniu",
  "Permission to Access Photo Library Necessary": "Potrzebny dostęp do zdjęć",
  "Could not access selected video.": "Brak dostępu do wybranego wideo.",
  "Could not open the video.": "Nie udało się otworzyć wideo.",
  "This video may still be in iCloud. Open Photos, download it to this iPhone, and try again.": "To wideo może nadal być w iCloud. Otwórz aplikację Zdjęcia, pobierz je na tego iPhone'a i spróbuj ponownie.",
  "Please try again, or choose another video.": "Spróbuj ponownie lub wybierz inne wideo.",
  "Could not open video library.": "Nie udało się otworzyć galerii wideo.",
  "Please check if permissions are given": "Sprawdź, czy aplikacja ma wymagane uprawnienia",
  "Could not start video upload.": "Nie udało się rozpocząć przesyłania wideo.",
  "Please try another video or check photo permissions in iOS Settings.": "Wybierz inne wideo lub sprawdź uprawnienia dostępu do zdjęć w Ustawieniach iOS.",
  "Only mov or mp4 files are accepted": "Akceptowane są tylko pliki mov lub mp4",
  "Cancel this upload?": "Anulować przesyłanie?",
  "The part already uploaded will be discarded.": "Przesłana już część zostanie odrzucona.",
  "Cancel upload": "Anuluj przesyłanie",
  "Keep uploading": "Kontynuuj przesyłanie",
  "{loaded} from {total}": "{loaded} z {total}",
  "Uploading...": "Przesyłanie...",
  "Video Uploaded": "Przesłano wideo",
  "Converting Video. This may take a few minutes.": "Konwertowanie wideo. To może potrwać kilka minut.",
  "Replace live video": "Zastąp wideo z transmisji",
  "MOV or MP4 video. 10GB Max.": "Wideo MOV lub MP4. Maks. 10 GB.",
  "Failed to start upload": "Nie udało się rozpocząć przesyłania",
  "Trim the video": "Przytnij wideo",
  "trim|From": "Od",
  "Enter start time in hh:mm:ss format if you want to clip the beginning of the video. For example, if you want to start the video 20 minutes into the live stream, enter \"00:20:00\"": "Jeśli chcesz obciąć początek wideo, wpisz czas rozpoczęcia w formacie hh:mm:ss. Na przykład, aby wideo zaczynało się od 20. minuty transmisji na żywo, wpisz „00:20:00”",
  "MOV or MP4 video. Up to 200 GB.": "Wideo MOV lub MP4. Do 200 GB.",
  "upload status|converted": "przekonwertowane",
  "upload status|converting": "w trakcie konwersji",
  "upload status|waiting to convert": "oczekuje na konwersję",
  "This video was already uploaded for this event (status: {status}).": "To wideo zostało już przesłane do tego wydarzenia (stan: {status}).",
  "{part} of {total} {unit}": "{part} z {total} {unit}",
  "Resuming — {sizes} were already uploaded": "Wznawianie — przesłano już {sizes}",
  "Starting over — nothing had finished uploading yet": "Rozpoczynanie od nowa — nic nie zostało jeszcze przesłane w całości",
  "under a minute left": "pozostała niecała minuta",
  "about {count} min left": {
    "one": "pozostało ok. {count} min",
    "few": "pozostało ok. {count} min",
    "many": "pozostało ok. {count} min"
  },
  "about {count} h {minutes} min left": {
    "one": "pozostało ok. {count} godz. {minutes} min",
    "few": "pozostało ok. {count} godz. {minutes} min",
    "many": "pozostało ok. {count} godz. {minutes} min"
  },
  "about {count} h left": {
    "one": "pozostało ok. {count} godz.",
    "few": "pozostało ok. {count} godz.",
    "many": "pozostało ok. {count} godz."
  },
  "Pause": "Wstrzymaj",
  "Resume": "Wznów",
  "Upload again": "Prześlij ponownie",
  "upload card|View event page": "Zobacz stronę wydarzenia",
  "You can leave this page meanwhile.": "W międzyczasie możesz opuścić tę stronę.",
  "Processing starting soon": "Przetwarzanie wkrótce się rozpocznie",
  "We're finishing other videos first. You can leave this page meanwhile.": "Najpierw kończymy przetwarzać inne wideo. W międzyczasie możesz opuścić tę stronę.",
  "Waiting for processing…": "Oczekiwanie na przetworzenie…",
  "Preparing your video…": "Przygotowywanie wideo…",
  "Publishing to your event page…": "Publikowanie na stronie wydarzenia…",
  "Almost done.": "Prawie gotowe.",
  "Still processing…": "Nadal trwa przetwarzanie…",
  "Processing video… {percent}%": "Przetwarzanie wideo… {percent}%",
  "Uploading video": "Przesyłanie wideo",
  "Waiting for network…": "Oczekiwanie na połączenie z siecią…",
  "Starting the upload…": "Rozpoczynanie przesyłania…",
  "Calculating time left…": "Obliczanie pozostałego czasu…",
  "Paused": "Wstrzymano",
  "The upload continues where it stopped.": "Przesyłanie będzie kontynuowane od miejsca, w którym się zatrzymało.",
  "Finishing upload…": "Kończenie przesyłania…",
  "Putting the video together.": "Łączenie wideo w całość.",
  "{size} uploaded": "Przesłano {size}",
  "Your video is ready": "Wideo jest gotowe",
  "It's on your event page now.": "Jest już na stronie wydarzenia.",
  "Upload interrupted": "Przesyłanie przerwane",
  "Already uploaded": "Wideo już przesłane",
  "Upload cancelled": "Przesyłanie anulowane",
  "This upload was cancelled. The event's video hasn't changed.": "Przesyłanie zostało anulowane. Wideo wydarzenia się nie zmieniło.",
  "Could not open the video. Please try again.": "Nie udało się otworzyć wideo. Spróbuj ponownie.",
  "Discard this unfinished upload?": "Odrzucić to niedokończone przesyłanie?",
  "The part already uploaded will be deleted.": "Przesłana już część zostanie usunięta.",
  "Discard upload": "Odrzuć przesyłanie",
  "upload|Keep it": "Zachowaj",
  "It replaces the event's video.": "Zastąpi wideo wydarzenia.",
  "It goes at the end of the event's video.": "Trafi na koniec wideo wydarzenia.",
  "It goes at the beginning of the event's video.": "Trafi na początek wideo wydarzenia.",
  "It goes between the event's video fragments.": "Trafi między fragmenty wideo wydarzenia.",
  "Try again, or upload it again.": "Spróbuj ponownie lub prześlij je jeszcze raz.",
  "Please upload it again.": "Prześlij je ponownie.",
  "We couldn't process your video": "Nie udało się przetworzyć wideo",
  "“{filename}” was uploaded but couldn't be converted.": "Plik „{filename}” został przesłany, ale nie udało się go przekonwertować.",
  "The video was uploaded but couldn't be converted.": "Wideo zostało przesłane, ale nie udało się go przekonwertować.",
  "If it keeps happening, contact support.": "Jeśli problem się powtarza, skontaktuj się z pomocą techniczną.",
  "Trying again…": "Ponawianie…",
  "Try again →": "Spróbuj ponownie →",
  "Contact support →": "Skontaktuj się z pomocą techniczną →",
  "notice|Dismiss": "Zamknij",
  "Unfinished upload": "Niedokończone przesyłanie",
  "“{filename}” ({size}), {percent}% uploaded.": "„{filename}” ({size}), przesłano {percent}%.",
  "Choose the same file to continue where the upload stopped.": "Wybierz ten sam plik, aby kontynuować przesyłanie od miejsca, w którym się zatrzymało.",
  "Resume upload →": "Wznów przesyłanie →",
  "Discard": "Odrzuć",
  "Photo Library": "Biblioteka zdjęć",
  "Files": "Pliki",
  "Choose a video": "Wybierz wideo",
  "Your event is live. Upload after the stream ends.": "Twoje wydarzenie trwa na żywo. Prześlij wideo po zakończeniu transmisji.",
  "This event no longer exists.": "To wydarzenie już nie istnieje.",
  "You don't have access to upload video to this event.": "Nie masz uprawnień do przesyłania wideo do tego wydarzenia.",
  "This upload has expired. Please choose the file again.": "To przesyłanie wygasło. Wybierz plik ponownie.",
  "This upload has already finished or was cancelled.": "To przesyłanie zostało już zakończone lub anulowane.",
  "Some parts of the video haven't uploaded yet.": "Niektóre części wideo nie zostały jeszcze przesłane.",
  "The uploaded video doesn't match the file. Please upload it again.": "Przesłane wideo nie pasuje do pliku. Prześlij je ponownie.",
  "This video was already uploaded for this event.": "To wideo zostało już przesłane do tego wydarzenia.",
  "Too many uploads are in progress. Finish or cancel one, then try again.": "Trwa zbyt wiele przesyłań. Zakończ lub anuluj jedno z nich i spróbuj ponownie.",
  "This file is too large. Videos can be up to 200 GB.": "Ten plik jest za duży. Wideo może mieć maksymalnie 200 GB.",
  "This file is empty. Please choose another video.": "Ten plik jest pusty. Wybierz inne wideo.",
  "Please choose a video file (MP4 or MOV).": "Wybierz plik wideo (MP4 lub MOV).",
  "This upload couldn't be started. Please choose the file again.": "Nie udało się rozpocząć tego przesyłania. Wybierz plik ponownie.",
  "Video upload is temporarily unavailable. Please try again later.": "Przesyłanie wideo jest chwilowo niedostępne. Spróbuj ponownie później.",
  "Something went wrong on our side. Please try again.": "Coś poszło nie tak po naszej stronie. Spróbuj ponownie.",
  "This video can't be converted again. Please upload it again.": "Tego wideo nie można ponownie przekonwertować. Prześlij je jeszcze raz.",
  "This upload is no longer available. Please choose the file again.": "To przesyłanie nie jest już dostępne. Wybierz plik ponownie.",
  "This upload can't continue. Please choose the file again.": "Nie można kontynuować tego przesyłania. Wybierz plik ponownie.",
  "This file can't be uploaded. Please choose another video.": "Nie można przesłać tego pliku. Wybierz inne wideo.",
  "Too many uploads at once. Please wait a moment and try again.": "Zbyt wiele przesyłań naraz. Poczekaj chwilę i spróbuj ponownie.",
  "Could not reach the upload service. Check your internet connection and try again.": "Nie udało się połączyć z usługą przesyłania. Sprawdź połączenie z internetem i spróbuj ponownie.",
  "The upload was interrupted. Check your internet connection and try again.": "Przesyłanie zostało przerwane. Sprawdź połączenie z internetem i spróbuj ponownie.",
  "This upload doesn't match the file. Please choose the file again.": "To przesyłanie nie pasuje do pliku. Wybierz plik ponownie.",
  "Could not finish the upload. Please try again.": "Nie udało się zakończyć przesyłania. Spróbuj ponownie.",
  "Could not read the video file. Please choose it again.": "Nie udało się odczytać pliku wideo. Wybierz go ponownie.",
  "Another upload for this event is still in progress.": "Trwa jeszcze inne przesyłanie do tego wydarzenia.",
  "There's no upload to continue.": "Nie ma przesyłania do kontynuowania.",
  "Could not start the conversion again. Please try again later.": "Nie udało się ponownie uruchomić konwersji. Spróbuj ponownie później.",
  "Choose the file again to continue the upload.": "Wybierz plik ponownie, aby kontynuować przesyłanie.",
  "That's a different file. Choose “{name}” to continue this upload.": "To inny plik. Wybierz „{name}”, aby kontynuować to przesyłanie.",
  "Choose a video file.": "Wybierz plik wideo.",
  "There isn't enough free space on this device to continue the upload. Free up some space, then try again.": "Na tym urządzeniu nie ma wystarczająco dużo wolnego miejsca, aby kontynuować przesyłanie. Zwolnij trochę miejsca i spróbuj ponownie.",
  "This upload was cancelled.": "To przesyłanie zostało anulowane.",
  "Upload failed": "Przesyłanie nie powiodło się",
  "Upload File": "Prześlij plik",
  "File uploaded": "Przesłano plik",
  "Guest list saved to Files": "Zapisano listę gości w aplikacji Pliki",
  "Downloads > {filename}": "Pobrane > {filename}",
  "Files > On my iPhone > EventLive > {filename}": "Pliki > Na moim iPhonie > EventLive > {filename}",
  "Could not save the file.": "Nie udało się zapisać pliku.",
  "Please try again on web": "Spróbuj ponownie w przeglądarce"
}
